import React from 'react';

import { ServicePageLayoutComponent } from 'design/servicePageLayout';

import { ProdStackManagerContentGuest } from 'containers/ProdStackManager/ProdStackManagerContentGuest';
import { ProdStackManagerContentAuthorized } from 'containers/ProdStackManager/ProdStackManagerContentAuthorized';
import { useAppState } from 'hooks/useAppState';
import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LogoComponent } from 'design/logo';
import { ThemeProviderComponent } from 'design/themeProvider';
import { ErrorBoundaryComponent } from 'utils/errorBoundary/errorBoundaryComponents';
import { OutOfResourcesError } from 'utils/errors';
import { ProdStackManagerFallback } from 'containers/ProdStackManager/ProdStackManagerFallback';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { AccountControls } from 'containers/AccountControls';

export const ProdStackManager = () => {
  const { authType } = useAppState();

  const contentNode = React.useMemo(() => {
    switch (authType) {
      case 'MANUAL':
      case 'IMPLICIT':
        return <ProdStackManagerContentAuthorized />;
      case 'NONE':
        return <ProdStackManagerContentGuest />;
      default:
        return null;
    }
  }, [authType]);

  return (
    <ThemeProviderComponent mode="onLight">
      <ServicePageLayoutComponent
        theme="light"
        logo={
          <LinkControlComponent to={ORIGIN_SITE_URL}>
            <TextComponent color="primary" size="l">
              <LogoComponent />
            </TextComponent>
          </LinkControlComponent>
        }
        bodyContent={
          <ErrorBoundaryComponent
            errorConstructorsToCatch={[OutOfResourcesError]}
            fallbackComponent={ProdStackManagerFallback}
          >
            <AsyncBoundaryComponent
              fallback={
                <CenteredLayoutComponent noOverlay>
                  <SpinnerExtraLarge />
                </CenteredLayoutComponent>
              }
            >
              {contentNode}
            </AsyncBoundaryComponent>
          </ErrorBoundaryComponent>
        }
        accountControls={
          <AccountControls redirectOnSignedOutTo={ORIGIN_SITE_URL} />
        }
      />
    </ThemeProviderComponent>
  );
};
